'use strict'
; (function () {
    var ColumnstoDisplayModuleModuleRoutingInfo = [
        {
            "name": "Columns_To_Display",
            "templateUrl": "<div emr-columnsto-display></div>",
            "RoutingNumber": 723,
            "files": [
                "AngularScripts/ColumnsToDisplay/Services/ColumnstoDisplayService.js",
                "AngularScripts/ColumnsToDisplay/Controllers/ColumnstoDisplayController.js",
            ]
        }
    ];
    angular.module('EMR.ColumnstoDisplayModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(ColumnstoDisplayModuleModuleRoutingInfo, $stateProvider);
            }]);


})();